import axios from 'axios';

import { HOST_API } from 'src/config-global';

// ----------------------------------------------------------------------

const axiosInstance = axios.create({ baseURL: HOST_API, withCredentials: true });

axiosInstance.interceptors.response.use(
  (res) => res,
  (error) => Promise.reject((error.response && error.response.data) || 'Something went wrong')
);

export default axiosInstance;

// ----------------------------------------------------------------------

export const fetcher = async (args) => {
  const [url, config] = Array.isArray(args) ? args : [args];

  const res = await axiosInstance.get(url, { ...config });

  return res.data;
};

// ----------------------------------------------------------------------

export const endpoints = {
  auth: {
    me: '/api/auth/me',
    login: '/api/auth/login',
    logout: '/api/auth/logout',
  },
  post: {
    list: '/api/post/list',
    details: '/api/post/details',
    latest: '/api/post/latest',
    search: '/api/post/search',
    createpost: '/api/post/create',
    update: 'api/post/update',
    delete: '/api/post/delete',
    upload: 'api/post/fileupload',
  },
  experience: {
    list: '/api/career-journey/list',
    worklist: '/api/work/list',
  },
  product: {
    create: '/api/products/create',
    list: '/api/products/list',
    details: '/api/products/details',
    search: '/api/products/search',
  },
  checkout: {
    create: '/api/sourcecode/create',
    verifypayment: '/api/sourcecode/verify/payment',
  },
  common: {
    contact: '/api/contact',
    download: '/api/resume/download',
  },
};
